export const Base_url = 'https://api.setkaya.az/api/'
export const img_url = 'https://api.setkaya.az/storage/'